import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import routes from "routes";
import "../../css/style.css";
import "../../css/variable.css";
import { FaBars } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { getSettingsData } from "services/_settings";

const UserNavbar = () => {
  const location = useLocation();
  const userRoutes = routes.filter((route) => route.layout === "/user");
  const [menuOpen, setMenuOpen] = useState(false);
  const [settingData, setSettingData] = useState({});

  // Function to check if the route is active
  const isActive = (path) => location.pathname === path;

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
    document.body.classList.toggle("active");
  };

  const getInitialValue = async () => {
    const response = await getSettingsData();
    if (response.isSuccess) {
      const settingsObject = response.data.reduce((acc, setting) => {
        acc[setting.key] = setting.value;
        return acc;
      }, {});

      setSettingData(settingsObject);
    }
  };
  useEffect(() => {
    getInitialValue();
  }, []);

  return (
    <>
      <div className="body_overly" />
      <header>
        <div className="container-nav flex w-full justify-between items-center mx-auto">
          <Link to="/home" className="text-[32px] font-[800] logo ">
            {settingData.company_name}
          </Link>

          <div className={`${menuOpen ? " active_header " : ""} header`}>
            <div className={`${menuOpen ? "active" : ""} navlink`}>
              <ul className="flex gap-[7px] items-center">
                {userRoutes.map((route) => (
                  <li key={route.path} onClick={toggleMenu}>
                    <Link
                      to={route.path}
                      className={`${
                        isActive(route.path) ? "active" : ""
                      } nav-link text-[16px] font-[500] p-[8px] px-[6px] `}
                    >
                      <span>{route.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <button id="barButton" className="bar_button" onClick={toggleMenu}>
            {menuOpen ? (
              <IoMdClose className="text-[30px]" />
            ) : (
              <FaBars className="text-[30px]" />
            )}
          </button>
        </div>
      </header>
    </>
  );
};

export default UserNavbar;
